<template v-if="!!data">
    <vue-svgicon
        role="img"
        class="flex-shrink-0"
        :data="data"
        :fill="true"
        v-bind="$attrs"/>
</template>

<script lang="ts">
/*
    See possibilities for attribs here: https://mmf-fe.github.io/svgicon/en/guide/advanced.html#component
 */

import { computed, defineComponent } from 'vue';

const icons = import.meta.glob('@/core/icons/*.svg', {
    import: 'default',  // we want the transformed SVG string, not the module object
    eager: true,        // load immediately so we can synchronously look them up
});

export default defineComponent({
    name: 'CIcon',
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const data = computed(() => icons[`/src/core/icons/${props.name}.svg`]);
        return { data };
    },
});
</script>
